import React, { useState, useEffect } from "react"
import { MenuButton } from "./MenuButton/menuButton"
import { Copyrights } from "./Copyrights/copyrights"
import { EST } from "./EST/est"
import { FoundationLogo } from "./FoundationLogo/foundationLogo"
import { BeksinskiSignature } from "./BeksinskiSignature/beksinskiSignature"
import { Links } from "./Links/links"
import { Navigation } from "./Navigation/navigation"
import { LanguageSelector } from "./LanguageSelector"

export const Menu = () => {
  const [active, setActive] = useState(false)
  const [canToggleMenu, setCanToggleMenu] = useState(true)
  const [mainPage, setMainPage] = useState(false) 
  // let mainPage = window.location.pat hname == "/"
  const [light, setLight] = useState(false)
  const isBrowser = typeof window !== `undefined`
  
  useEffect(() => {
    if (isBrowser) {
      setMainPage(window.location.pathname === "/")
      setLight(window.location.pathname === '/')
    }
  }, [])

  return (
    <div>
      <Navigation active={active} setCanToggle={setCanToggleMenu} />
      {(!mainPage || active) && <Copyrights light={light} active={active} />}
      <EST light={light} active={active} />
      {(active || mainPage) && <FoundationLogo light={light} active={active} />}
      {mainPage && <BeksinskiSignature light={light} active={active} />}
      {(mainPage || active) && <Links light={light} active={active} />}
      <LanguageSelector light={light} active={active} />
      <MenuButton
        light={light}
        active={active}
        menuButtonClicked={() => {
          if (canToggleMenu) setActive(!active)
        }}
      />
    </div>
  )
}
